module.exports = __webpack_public_path__ + "static/media/tiktok_logo.d5024c26.png";